import React from "react";
import { SectionTitle } from "../common";
import { useAdvisory } from "../../hooks/useAdvisory";
import { useTeam } from "../../hooks/useTeam";

const AdvisorySection: React.FC = () => {
  const { aboutMember, members } = useAdvisory();
  const { teamMembers } = useTeam();
  return (
    <section className="about-advisory-section py-5">
      <div className="container">
        <SectionTitle subtitle={aboutMember?.title || "[ Advisory ]"} title={aboutMember?.description || "Advisory Members"} />

        <div className="row g-4">
          {members.length > 0 ? members.map((member, index) => (
            <div key={member.id || index} className="col-lg-3 col-md-6 col-sm-6">
              <div className="advisory-card">
                <div
                  className="advisory-card-photo"
                  style={{
                    backgroundImage: `url('${member.image}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                ></div>
                <div className="advisory-card-gradient"></div>
                <div className="advisory-card-text">
                  <div className="advisory-card-title">{member.title}</div>
                  <div className="advisory-card-name">{member.name}</div>
                  <div className="advisory-card-job">{member.description}</div>
                </div>
              </div>
            </div>
          )) : (
            <div className="col-12">
              <p style={{ textAlign: 'center', color: '#273351' }}>Loading advisory members...</p>
            </div>
          )}
        </div>

        <div className="section-title" style={{ marginTop: '6rem', marginBottom: '3rem' }}>
          <div className="subtitle">[OUR TEAM]</div>
        </div>

        <div className="row g-4">
          {teamMembers.length > 0 ? (
            teamMembers.map((member, index) => (
              <div key={member.id || index} className="col-lg-3 col-md-6 col-sm-6">
                <div className="advisory-card">
                  <div
                    className="advisory-card-photo"
                    style={{
                      backgroundImage: `url('${member.image}')`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  <div className="advisory-card-gradient"></div>
                  <div className="advisory-card-text">
                    <div className="advisory-card-title">{member.title}</div>
                    <div className="advisory-card-name">{member.name}</div>
                    <div className="advisory-card-job">{member.description}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p style={{ textAlign: "center", color: "#273351" }}>Loading team members...</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AdvisorySection;

